<button class="toggle sp-mr-4" [attr.aria-expanded]="expanded" [attr.aria-label]="ariaLabel" (click)="toggleCollapse()" ui-button uiType="link" uiShape="round" tabindex="0">
  <i class="fs-20px" [uiType]="iconType" ui-icon></i>
</button>

<div class="columns" tabindex="-1">
  <div *ngFor="let column of columns; let idx = index" [ngStyle]="{ flex: column.flex }">
    <div class="title-wrap">
      <span *ngIf="idx === 0 && firstColumnPrefix">{{ firstColumnPrefix }}</span>
      <span *ngIf="column.alwaysVisible || expanded">{{ column.label }}</span>
    </div>
  </div>
</div>
